import IFileService from "data/IFileService";
import DocumentSimplifiedDTO from "features/invoices/dtos/DocumentSimplifiedDTO";
import { useInjection } from "infrastructure/ioc/ioc.react";
import { IocTypes } from "infrastructure/ioc/ioc.types";
import React from "react";
import RoundButton from "features/shared/components/buttons/RoundButton";

type DownloadErrorHandler = {
  catchError: boolean;
  onError: () => void;
};

type Props = {
  document: DocumentSimplifiedDTO;
  loadingAreaName?: string;
  errorHandler?: DownloadErrorHandler;
};

const DocumentDownload = ({
  document,
  loadingAreaName,
  errorHandler,
}: Props) => {
  // DI
  const fileService = useInjection<IFileService>(IocTypes.FileService);

  // hadlers
  const fileDownloadHandler = async () => {
    if (errorHandler && errorHandler.catchError) {
      try {
        await fileService.downloadDocument(document, loadingAreaName, false);
      } catch (error) {
        errorHandler.onError();
      }
    } else {
      await fileService.downloadDocument(document, loadingAreaName);
    }
  };

  // render
  return (
    <div className="row no-gutters align-items-center">
      <div className="col">
        <div className="text-truncate">{document.name}</div>
        <div className="text-muted small">{document.documentType}</div>
      </div>
      <div className="col-auto pl-3">
        <RoundButton icon="download" onClickHandler={fileDownloadHandler} />
      </div>
    </div>
  );
};

export default DocumentDownload;
